import { useParams } from "react-router-dom";
import { useAssetDetail } from "../../hooks";
import { AssetKeyMetricsCards } from "./AssetKeyMetricsRow";
import { AssetKeyStatsCard } from "./AssetKeyStatsCard";
import { AssetProfileCard } from "./AssetProfileCard";
import { AssetQuickActionsSidebar } from "./AssetQuickActionsSidebar";
import { AssetTabs } from "./DetailTabs/AssetTabs";
export default function AssetDetail() {
  const { id } = useParams();
  const { data: assetData } = useAssetDetail(id);

  return (
    <div className="p-4 space-y-3">
      <div className="space-y-6">
        <div className="space-y-6">
          <div className="grid grid-cols-12 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-8 space-y-6">
              <AssetProfileCard data={assetData} />
              <AssetKeyMetricsCards data={assetData} />
            </div>
            <div className="lg:col-span-4 space-y-4">
              <AssetKeyStatsCard data={assetData} />
              <AssetQuickActionsSidebar data={assetData} />
            </div>
          </div>

          {/* Tabs - Full Width */}
          <AssetTabs data={assetData} />
        </div>
      </div>
    </div>
  );
}
